import { render, staticRenderFns } from "./classification-sub-fw-form.vue?vue&type=template&id=66dde5cc&scoped=true&"
import script from "./classification-sub-fw-form.ts?vue&type=script&lang=ts&"
export * from "./classification-sub-fw-form.ts?vue&type=script&lang=ts&"
import style0 from "./classification-sub-fw-form.scss?vue&type=style&index=0&id=66dde5cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dde5cc",
  null
  
)

export default component.exports